import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-main">
          <p className="footer-name">Alice Rey</p>
          <p className="footer-role">Software / Data / AI Engineer</p>
        </div>

        <div className="footer-links">
          <a
            href="https://github.com/alicereyy"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/alice-rey44/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <a href="mailto:alicerey@orange.fr">Email</a>
          <a href="/resume.pdf" 
            download="Alice_Rey_resume.pdf" 
            className="footer-download">
            Download Resume
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {currentYear} Alice Rey. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;